export default "__VITE_ASSET__1074a938__"